import React, { useEffect, useId, useState } from "react";
import {
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import LoginHeader from "../header/LoginHeader";
import { useIds } from "../../hook/AdminContext";

export default function LogoOnlyLayout() {
  const navigate = useNavigate();
  const { fetctUserDetail, setUserToken, STOP_SOCKET_FORCEFULLY } = useIds();
  const [searchParams] = useSearchParams();
  const paramsToken = searchParams.get("token");
  const requestId = searchParams.get("request_id");
  const userId = searchParams.get("user_id");
  const pageRedirect = searchParams.get("page_redirect");
  const token = localStorage.getItem("token");
  const user = localStorage.getItem("user");

  const handleRedirect = async () => {
    if (paramsToken && userId) {
      localStorage.clear();
      STOP_SOCKET_FORCEFULLY();
      localStorage.setItem("token", paramsToken);
      setUserToken(paramsToken);
      localStorage.setItem("user", JSON.stringify({ _id: userId }));
      await fetctUserDetail();
      if (pageRedirect && requestId) {
        navigate(`/${pageRedirect}/${requestId}`);
      } else if (pageRedirect) {
        navigate(`/${pageRedirect}`);
      } else {
        navigate(`/home`);
      }
    } else if (!token || !user) {
      localStorage.clear();
    } else {
      navigate("/home");
    }
  };

  useEffect(() => {
    handleRedirect();
  }, []);

  return (
    <>
      <LoginHeader />
      <div className="logo-only-layout-container position-relative">
        <Outlet className="container-fluid" />
      </div>
    </>
  );
}
